import 'angular';

import uiModal from '@cian/ui/app/components/modal/index.jsm';
import './serp/serp-modal.less';



// WEBPACK FOOTER //
// ./src/ui-modal-entry.js